import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import { Navbar as BSNavbar, Container, Nav } from 'react-bootstrap';
import { FaHome, FaImages, FaBars, FaTimes, FaSearch, FaUser } from 'react-icons/fa';
import styles from './Navbar.module.css';

export default function Navbar() {
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();
  
  // Close mobile menu when location changes
  useEffect(() => {
    setExpanded(false);
  }, [location]);

  // Helper function to check if a nav item is active
  const isActive = (path: string) => {
    return location.pathname === path || 
           (path !== '/' && location.pathname.startsWith(path));
  }; 
  
  // Nav link component with active state
  const NavItem = ({ to, icon: Icon, children }: { to: string; icon: React.ElementType; children: React.ReactNode }) => (
    <Nav.Link 
      as={Link} 
      to={to}
      className={`${styles.navLink} ${isActive(to) ? styles.active : ''}`}
    >
      <Icon className="me-2" style={{ minWidth: '20px' }} />
      {children}
    </Nav.Link>
  );

  return (
    <BSNavbar 
      bg="dark" 
      variant="dark" 
      expand="lg" 
      expanded={expanded}
      className="mb-4"
      style={{
        boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
        position: 'sticky',
        top: 0,
        zIndex: 1030
      }}
    >
      <Container fluid className="px-3 px-md-4">
        <BSNavbar.Brand 
          as={Link} 
          to="/" 
          className="d-flex align-items-center"
          style={{
            fontWeight: 700,
            letterSpacing: '0.5px',
            fontSize: '1.4rem',
            background: 'linear-gradient(90deg, #6a11cb 0%, #2575fc 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}
        >
          <span style={{ whiteSpace: 'nowrap' }}>Excelsior</span>
          <span className="d-none d-sm-inline" style={{ marginLeft: '4px' }}>NFT Collection</span>
        </BSNavbar.Brand>
        
        <BSNavbar.Toggle 
          aria-controls="responsive-navbar-nav" 
          onClick={() => setExpanded(expanded ? false : true)}
          className={`border-0 ${styles.navbarToggler}`}
          style={{
            fontSize: '1.5rem',
            color: '#fff'
          }}
        >
          {expanded ? <FaTimes /> : <FaBars />}
        </BSNavbar.Toggle>
        
        <BSNavbar.Collapse id="responsive-navbar-nav" className={styles.navbarCollapse}>
          <Nav className="me-auto mt-2 mt-lg-0">
            <NavItem to="/" icon={FaHome}>
              <span className="d-none d-lg-inline">Home</span>
            </NavItem>
            <NavItem to="/nft-gallery" icon={FaImages}>
              <span className="d-none d-lg-inline">My NFTs</span>
            </NavItem>
            <NavItem to="/explore" icon={FaSearch}>
              <span className="d-none d-lg-inline">Explore</span>
            </NavItem>
            <NavItem to="/profile" icon={FaUser}>
              <span className="d-none d-lg-inline">Profile</span>
            </NavItem>
          </Nav>
          
          <div className={`d-flex flex-column flex-lg-row align-items-center mt-3 mt-lg-0 ms-lg-3 ${styles.connectWalletWrapper}`}>
            <div className={styles.connectWalletWrapper} style={{ minWidth: '200px' }}>
              <ConnectButton 
                label="Connect Wallet"
                accountStatus="address"
                chainStatus="icon"
                showBalance={false}
              />
            </div>
          </div>
        </BSNavbar.Collapse>
      </Container>
    </BSNavbar>
  );
}
